/**
 * @license @lucide/lab v0.1.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const crosshair2 = [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M22 12h-4", key: "pliqo5" }],
  ["path", { d: "M6 12H2", key: "17rm5b" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
];

export { crosshair2 as default };
//# sourceMappingURL=crosshair-2.js.map
